import React from 'react';

export default function PoiDisplay({ poi, isNew = false }) {
  const displayName = poi.name || `POI #${poi.id}`;
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';
  const hasCoordinates =
    poi.lat !== undefined &&
    poi.lat !== null &&
    poi.lon !== undefined &&
    poi.lon !== null;

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i className="fa-regular fa-map-marker-alt text-red-500" />
      <div className="flex-1">
        <span className="text-sm text-gray-700">{displayName}</span>
        {hasCoordinates && (
          <div className="text-xs text-gray-500">
            {poi.lat.toFixed(6)}, {poi.lon.toFixed(6)}
          </div>
        )}
      </div>
    </div>
  );
}
